'use client';

import { type ReactNode, useMemo } from 'react';
import { colors, createTheme, CssBaseline, ThemeProvider } from '@mui/material';

export const CorporateTheme = (props: {
	children: ReactNode;
	color: string;
	fontFamily: 'Open Sans' | 'titillium';
}) => {
	const theme = useMemo(
		() =>
			createTheme({
				palette: {
					primary: {
						main: '#ec6c1d',
						contrastText: colors.common.white,
					},
					secondary: {
						main: props.color.trim(),
						contrastText: colors.common.white,
					},
					text: {
						primary: colors.common.black,
						secondary: colors.common.white,
					},
				},
				typography: {
					allVariants: {
						fontFamily: props.fontFamily,
						fontWeight: 400,
						color: 'black',
					},
				},
				breakpoints: {
					values: {
						xs: 0,
						sm: 768,
						md: 1024,
						lg: 1366,
						xl: 1400,
					},
				},
			}),
		[props.color, props.fontFamily],
	);

	return (
		<ThemeProvider theme={theme}>
			{/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
			<CssBaseline />
			{props.children}
		</ThemeProvider>
	);
};
